import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  async submit(event) {
    event.preventDefault()
    
    const form = event.target
    const formData = new FormData(form)
    
    // Map country to currency code
    const countryToCurrency = {
      'NG': 'NGN'
    }
    
    const country = formData.get('country')
    const currencyCode = countryToCurrency[country] || 'NGN'
    const amount = formData.get('amount')
    
    // Build query parameters
    const params = new URLSearchParams({
      amount: amount,
      currency_code: currencyCode
    })
    
    // Add user_id if present in URL (for admin viewing another user's wallet)
    const urlParams = new URLSearchParams(window.location.search)
    const userId = urlParams.get('user_id')
    if (userId) {
      params.append('user_id', userId)
    }
    
    try {
      // Call the paygate API
      const response = await fetch(`/api/v1/paygate/checkout_link?${params}`, {
        method: 'GET',
        headers: {
          'X-CSRF-Token': this.getCsrfToken()
        },
        credentials: 'same-origin'
      })
      
      if (!response.ok) {
        throw new Error('Failed to get checkout link')
      }
      
      const data = await response.json()
      
      // Open checkout URL in a new tab
      window.open(data.url, '_blank')
    } catch (error) {
      console.error('Payment error:', error)
      alert('There was an error processing your payment. Please try again.')
    }
  }
  
  getAuthToken() {
    // For API authentication, we might need JWT token
    return localStorage.getItem('jwt_token') || ''
  }
  
  getCsrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ''
  }
}